import React, { Component } from 'react';
import { ReportingLibrary } from '@lyearn-team/reporting-library';
import Relay from 'react-relay/classic';
import { css } from 'emotion';
import $j from 'jquery';
import PropTypes from 'prop-types';
import Radium, { Style } from 'radium';
import cloneDeep from 'lodash/cloneDeep';
import throttle from 'lodash/throttle';
import findIndex from 'lodash/findIndex';
import moment from 'moment';
import Events from 'helper/ReportingDashboard/utils/eventsList';
import reportRequest from 'helper/ReportingDashboard';
import getContentByIds from 'admin/views/AdminReports/utils/getReportData/getContentByIds';
import { LessonEventsFromEnum } from 'appConsts';

import { interactionsBlocked } from '../../../helper/blockUserInteractionHelper';
import * as DateHelper from '../../../helper/DateHelper';
import CardTopView from './CardTopView/index';
import HTMLCard from './HTMLCard';
import SCORMCard from './ScormCard';
import AssignmentCard from './AssignmentCard';
import ObjectiveAssignmentCard from './ObjectiveAssignmentCard';
import AudioCard from './AudioCard/index';
import VideoPlayer from './VideoCard';
import PDFCard from './PDFCard';
import BlockCard from './BlockCard';
import PeerReview from './PeerReview';
import WindowResize from '../../../helper/WindowResize';
import Icon from '../../../helper/Icon';
import SetProgressMeasureMutation from '../../mutations/SetProgressMeasureMutation';
import StickyNarrationPlayer from './StickyNarrationPlayer';

const cardInternalContainer = css`
  @media (min-width: 767px) and (max-height: 700px) {
    margin: 0px auto 10px !important;
    min-height: calc(100vh - 80px) !important;
    padding-top: 130px !important;
  }
`;

const liveClassCardContainer = css`
  margin: 0px auto !important;
  min-height: calc(100vh - 80px) !important;
  padding-top: 180px !important;
  padding-bottom: 100px !important;
`;

@Radium
class LearnerCard extends Component {
  static childContextTypes = {
    toggleFullscreen: PropTypes.func
  };

  static contextTypes = {
    router: PropTypes.object,
    getFeatureFlag: PropTypes.func,
    showNavigation: PropTypes.func
  };

  constructor(props) {
    super(props);
    const remainingTime = this.calculateRemainingTime(this.props.rootQ);
    this.state = {
      showNarration: false,
      startsFromFirst: true,
      fullScreen: false,
      remainingTime,
      isAssignmentFullScreen: false,
      narrationUrl: ''
    };
    this.timerRunning = false;
    this.rp = new ReportingLibrary();
  }

  getChildContext() {
    return {
      toggleFullscreen: this.toggleFullscreen
    };
  }

  cardCompleted = false;

  UNSAFE_componentWillMount() {
    this.props.dataFetched &&
      this.props.dataFetched('card', this.props.rootQ.pid, this.props.rootQ.name);
    this.cardCompleted =
      this.props.rootQ.performance && this.props.rootQ.performance.completionStatus === 'COMPLETE';
    if (this.props.rootQ.autoPlay) {
      this.state.showNarration = true;
      this.state.showMobileNarration = true;
    }
    this.context.showNavigation && this.context.showNavigation(false);
    // $j('.mainWrapperInner').css('min-height', '100vh');
    // $j('body').css('margin-top', '0px');
    // $j('.sideView').css('top', '0px');

    $j('.topNavBreadcrumb').hide();
    const prerequisites = this.props.course.prerequisites;
    const ifAllPrequisitesComplete = this.checkPrerequisites(prerequisites);
    const deactivateFrom = this.props.course.deactivateFrom;
    if (deactivateFrom && moment().isAfter(moment(deactivateFrom))) {
      this.changePath('/deactivate');
    }
    if (
      ((deactivateFrom && moment().isBefore(moment(deactivateFrom))) || !deactivateFrom) &&
      prerequisites &&
      prerequisites.length > 0 &&
      !ifAllPrequisitesComplete
    ) {
      this.changePath('/pre-requisites');
    }
  }

  changePath = pathKey => {
    if (window.location.href.indexOf('/paths') > -1) {
      this.props.history.replace(
        '/learner/home/paths/' +
          (this.props.pathInfo && this.props.pathInfo.pid) +
          '/courses/' +
          this.props.course.pid +
          pathKey
      );
    } else if (window.location.href.indexOf('home') > -1) {
      this.props.history.replace('/learner/home/courses/' + this.props.course.pid + pathKey);
    } else if (window.location.href.indexOf('learner/courses') > -1) {
      this.props.history.replace('/learner/courses/' + this.props.course.pid + pathKey);
    }
  };

  checkPrerequisites = prerequisites => {
    if (!prerequisites) return null;
    return (
      prerequisites.filter(obj => {
        let isDone = obj.course.coursePerformance;
        if (obj.unlockCriteria === 'COMPLETE' && obj.course.coursePerformance) {
          isDone = obj.course.coursePerformance.completionStatus.toLowerCase() === 'complete';
        }
        return isDone;
      }).length === prerequisites.length
    );
  };

  calculateRemainingTime = card => {
    const calculatedDuration = this.calculateReqCardDuration(card);
    if (card.performance) {
      if (calculatedDuration > card.performance.timeSpent) {
        return calculatedDuration - card.performance.timeSpent;
      }
      return 0;
    }
    return calculatedDuration;
  };

  calculateReqCardDuration = card =>
    card.minProgressMeasure ? Math.round(card.minProgressMeasure * card.duration) : card.duration;

  setCardProgressBar = (cardDuration, remainingTime, set100Percentage) => {
    if (set100Percentage) {
      this.refs.cardTopView &&
        this.refs.cardTopView.refs.component &&
        this.refs.cardTopView.refs.component.cardProgressRef &&
        this.refs.cardTopView.refs.component.cardProgressRef.setPercentage(100);
    } else {
      const percentage = (100 * (cardDuration - remainingTime)) / cardDuration;
      this.refs.cardTopView &&
        this.refs.cardTopView.refs.component &&
        this.refs.cardTopView.refs.component.cardProgressRef &&
        this.refs.cardTopView.refs.component.cardProgressRef.setPercentage(percentage);
    }
  };

  setRemainingTimeText = () => {
    $j('span.cardRemainingTimeLabel').html(this.timeRemaining);
  };

  startCountDown = (card, initialize) => {
    if (initialize) {
      const remainingTime = this.calculateRemainingTime(card);
      this.timeRemaining = DateHelper.getFormattedDurationInWords(remainingTime);
      this.state.remainingTime = remainingTime;
      this.setRemainingTimeText();
    }
    this.cardDuration = this.calculateReqCardDuration(card);
    this.setCardProgressBar(this.cardDuration, this.state.remainingTime);
    this.currentTime && clearInterval(this.currentTime);
    this.currentTime = setInterval(() => {
      if (window.isActive /* && window._isFocused */) {
        const remainingTime = this.timerRunning
          ? this.state.remainingTime
          : this.calculateRemainingTime(card);
        this.state.remainingTime = remainingTime - 1;
        this.timeRemaining = DateHelper.getFormattedDurationInWords(this.state.remainingTime);
        this.timerRunning = true;
        if (this.state.remainingTime >= 1) {
          this.setRemainingTimeText();
          this.setCardProgressBar(this.cardDuration, this.state.remainingTime);
        } else {
          this.setCardProgressBar(null, null, true);

          this.timeoutReached();
          this.clearCountDown();
          // this.setState({});
          // this.clearCountDown();
        }
      }
    }, 1000);
  };

  setProgressMeasureMutationFunc = (progressMeasure, immediateMutation) => {
    if (interactionsBlocked()) {
      return false;
    }
    const data = cloneDeep({
      courseId: this.props.course.pid,
      cardId: this.props.rootQ.pid,
      card: this.props.rootQ,
      progressMeasure,
      userId: this.props.userObj.pid,
      pathId: this.props.pathInfo && this.props.pathInfo.pid,
      coursePerformanceId:
        this.props.course.coursePerformance && this.props.course.coursePerformance.id,
      mainId: this.props.rootQ.performance && this.props.rootQ.performance.id,
      pathGraphId: this.props.pathInfo && this.props.pathInfo.id,
      userGraphId: this.props.userObj.id,
      courseGraphId: this.props.course.id,
      cardGraphId: this.props.rootQ.id
    });

    this.setProgressMeasureMutation(data);
    immediateMutation && this.setProgressMeasureMutation.flush();
  };

  setProgressMeasureMutation = throttle(
    mutationProps => {
      const mutation = new SetProgressMeasureMutation(mutationProps);
      mutation.commit({
        onSuccess: s => {
          // this.props.lessonProgressChangeCallback(this.props.rootQ.pid, this.props.rootQ.performance && this.props.rootQ.performance.scaledProgressMeasure, this.props.rootQ);
          console.log('Success at setProgressMeasureForLearningCard', JSON.stringify(s));
        },
        onFailure: t => {
          console.log('Failed at setProgressMeasureForLearningCard', t.getError());
        }
      });
    },
    10000,
    { leading: true, trailing: true }
  );

  setScrollPM = (
    progressMeasure,
    progressMeasureForView,
    doMutation,
    doAnimate,
    immediateMutation
  ) => {
    if (!this.props.isAccessible) {
      return false;
    }
    const percentage = progressMeasureForView * 100;
    this.refs.cardTopView &&
      this.refs.cardTopView.refs.component &&
      this.refs.cardTopView.refs.component.cardProgressRef &&
      this.refs.cardTopView.refs.component.cardProgressRef.setPercentage(percentage, doAnimate);
    doMutation && this.setProgressMeasureMutationFunc(progressMeasure, immediateMutation);
  };

  clearCountDown = () => {
    // if (this.timerRunning) {
    this.timerRunning = false;
    this.timeRemaining = null;
    this.currentTime && clearInterval(this.currentTime);
    // }
  };

  createReportRequest = () => {
    if (this.props.previewCourse || this.props.guestMode) {
      return false;
    }
    const {
      name: lessonName,
      globalPosition: lessonIndex,
      pid: cardId,
      type: lessonType
    } = this.props.rootQ;
    const { pid: courseId, name: courseName } = this.props.course;
    reportRequest(Events.CARD_OPENED, {
      courseId,
      courseName,
      cardId,
      lessonIndex,
      lessonName,
      lessonType
    });
  };

  syncLiveClassData = ({ isCardChanged, prevProps, currentProps }) => {
    if (!currentProps.isLiveClass) {
      return;
    }
    const card = currentProps.rootQ;
    const course = currentProps.course;
    const cardProgress = card.performance ? card.performance.scaledProgressMeasure : 0;
    const courseProgress = course.coursePerformance
      ? course.coursePerformance.scaledProgressMeasure
      : 0;

    if (isCardChanged) {
      if (currentProps.isTeacher) {
        currentProps.onTeacherCardChange(card.pid, currentProps.course.pid);
      }
      currentProps.onLearnerCardChange({
        cardPid: card.pid,
        cardProgress,
        globalPosition: card.globalPosition,
        coursePid: currentProps.course.pid,
        courseProgress
      });
    }
    if (!currentProps.isTeacher) {
      const prevPerformance = prevProps ? prevProps.rootQ.performance : null;
      const newPerformance = currentProps ? card.performance : null;
      const isCardCompleted =
        prevPerformance &&
        prevPerformance.completionStatus !== 'COMPLETE' &&
        newPerformance.completionStatus === 'COMPLETE';

      if (isCardCompleted) {
        currentProps.lessonCompletedCallback(card.pid, card);
      }
      const isProgressUpdated =
        prevPerformance &&
        prevPerformance.completionStatus !== 'COMPLETE' &&
        prevPerformance.scaledProgressMeasure !== newPerformance.scaledProgressMeasure;

      if (isProgressUpdated) {
        currentProps.lessonProgressChangeCallback({
          cardPid: card.pid,
          cardProgress,
          globalPosition: card.globalPosition,
          coursePid: currentProps.course.pid,
          courseProgress
        });
      }
    }
  };

  async componentDidMount() {
    const card = this.props.rootQ;
    this.createReportRequest();
    this.context.showNavigation && this.context.showNavigation(false);
    $j('.topNavBreadcrumb').hide();
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    if (this.props.previewCourse) {
      $j('.preview-course-wrapper')[0].scrollTop = 0;
    }
    if (
      card.completionType === 'TIME_BASED' &&
      this.state.remainingTime > 0 &&
      !this.props.previewCourse &&
      !this.props.guestMode
    ) {
      this.startCountDown(card);
    }
    this.syncLiveClassData({ isCardChanged: true, currentProps: this.props });
    // Open all a in new tab
    $j('#CardInternalContainer').off('click.external');
    $j('#CardInternalContainer').on('click.external', 'a', e => {
      if ($j(e.currentTarget).closest('.wistia_responsive_wrapper').length < 1) {
        // Ignore for Wistia player anchor tags
        e.preventDefault();
        window.open(e.currentTarget.getAttribute('href'));
      }
    });
    const contentId = this.props.course.pid;
    const cardId = this.props.rootQ.pid;
    await this.fetchNarrationUrl(contentId, cardId);
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    // card change
    //
    let isCardChanged = false;
    if (newProps.rootQ.pid !== this.props.rootQ.pid) {
      this.flushSetPMMutation(newProps);
      this.createReportRequest();
      const card = newProps.rootQ;
      this.clearCountDown();
      // this.removeScrollProgress();
      // this.resetScrollProgress();
      newProps.dataFetched && newProps.dataFetched('card', card.pid, card.name);
      this.state.fullScreen = false;
      isCardChanged = true;
      if (card.autoPlay) {
        this.state.showNarration = true;
        this.state.showMobileNarration = true;
      } else {
        this.state.showNarration = false;
        this.state.showMobileNarration = false;
      }
      const cardAlreadyComplete =
        card.performance && card.performance.completionStatus === 'COMPLETE';

      if (
        card.completionType === 'TIME_BASED' &&
        !this.props.previewCourse &&
        !this.props.guestMode
      ) {
        if (!card.performance || !cardAlreadyComplete) {
          this.startCountDown(card, true);
        }
      }
    }
    this.syncLiveClassData({ isCardChanged, currentProps: newProps, prevProps: this.props });

    if (newProps.rootQ.pid !== this.props.rootQ.pid && newProps.rootQ.type === 'assignmentCard') {
      this.clearCountDown();

      const currentCardIndex = findIndex(
        this.props.cardArray,
        card => card.pid === this.props.rootQ.pid
      );
      const nextCardIndex = newProps.cardArrayCurrentCardIndex;
      if (currentCardIndex > nextCardIndex) {
        this.setState({ startsFromFirst: false });
      } else if (currentCardIndex < nextCardIndex) {
        this.setState({ startsFromFirst: true });
      }
    }
    if (this.state.showNarration && this.props.rootQ.pid !== newProps.rootQ.pid) {
      // this.state.showNarration = false;
    }
    if (this.props.rootQ.performance) {
      if (this.props.rootQ.pid !== newProps.rootQ.pid) {
        this.cardCompleted = newProps.rootQ.performance.completionStatus === 'COMPLETE';
      } else if (
        newProps.rootQ.performance &&
        newProps.rootQ.performance.completionStatus === 'COMPLETE' &&
        this.cardCompleted === false
      ) {
        const cardTopView = this.refs.cardTopView.refs.component;
        cardTopView.assignmentCardCompleted(true);
      } else {
        this.cardCompleted =
          newProps.rootQ.performance && newProps.rootQ.performance.completionStatus === 'COMPLETE';
      }
    }
  }

  async componentDidUpdate(prevProps) {
    if (prevProps.rootQ.pid !== this.props.rootQ.pid) {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      const contentId = this.props.course.pid;
      const cardId = this.props.rootQ.pid;
      await this.fetchNarrationUrl(contentId, cardId);
      if (this.props.previewCourse && $j('.preview-course-wrapper')[0]) {
        $j('.preview-course-wrapper')[0].scrollTop = 0;
      }
    }
  }

  componentWillUnmount() {
    this.flushSetPMMutation(this.props);

    this.context.showNavigation && this.context.showNavigation(true);
    $j('.topNavBreadcrumb').show();
    this.clearCountDown();
  }

  getAssignmentFullScreenStatus = () => this.state.isAssignmentFullScreen;

  flushSetPMMutation = props => {
    if (props.rootQ.completionType === 'SCROLL_BASED') {
      this.setProgressMeasureMutation.flush();
    }
  };

  timeoutReached = () => {
    const cardTopView = this.refs.cardTopView.refs.component;
    cardTopView.addTime();
  };

  stopTimer = () => {
    this.timer && clearInterval(this.timer);
  };

  cardListMenuBtn = () => {
    const open = this.props.cardListMenuBtn();
    this.setState({
      menuOpen: open
    });
  };

  nextPressed = EventType => {
    if (typeof EventType === 'string') {
      this.props.nextPressed(EventType);
    } else {
      this.props.nextPressed(LessonEventsFromEnum.UI);
    }
  };

  updateAssignmentScreenStatus = value => {
    this.setState({ isAssignmentFullScreen: value });
  };

  renderAssignmentCardView = (cardArray, currentCardIndex) => (
    <div role="presentation" className="cardNextArrowWrapper" onClick={this.nextPressed}>
      <span className="arrowWrapperHead">Next lesson</span>
      <span className="lessonName">
        {cardArray[currentCardIndex + 1].globalPosition +
          ' ' +
          cardArray[currentCardIndex + 1].name}
      </span>
      <Icon icon="expand-more" size="10px" fill="#8392a7" viewBox="5 5 13 13" />
    </div>
  );

  renderNextArrow = (cardArray, currentCardIndex, card) => {
    if (currentCardIndex + 1 < cardArray.length) {
      if (card.completionType === 'TIME_BASED') {
        const isComplete = card.performance
          ? card.performance.completionStatus.toLowerCase() === 'complete'
          : false;
        // console.log('this.timeRemaining: ', this.state.remainingTime, this.timeRemaining);
        if (
          isComplete ||
          this.state.remainingTime <= 0 ||
          this.props.previewCourse ||
          this.props.guestMode
        ) {
          return this.renderAssignmentCardView(cardArray, currentCardIndex);
        }
        return (
          <div
            role="presentation"
            className="cardNextArrowWrapper learninCardNextArrowWrapper"
            onClick={this.nextPressed}
          >
            <div className="currentSesstionRemainingTime">
              <span>
                This lesson will complete in <span className="cardRemainingTimeLabel">...</span>
              </span>
            </div>
            <span className="lessonName goToNextLesson">next lesson</span>
            <Icon icon="expand-more" size="10px" fill="#8392a7" viewBox="5 5 13 13" />
          </div>
        );
      }
      return this.renderAssignmentCardView(cardArray, currentCardIndex);
    }
    return null;
  };

  fetchNarrationUrl = async (contentId, cardId) => {
    let narrationUrl = sessionStorage.getItem(cardId);
    if (!narrationUrl) {
      const cardDoc = await getContentByIds(this.rp, [cardId]);
      narrationUrl = cardDoc && cardDoc.content.narrationUrl ? cardDoc.content.narrationUrl : '';
      sessionStorage.setItem(cardId, narrationUrl);
    }
    this.setState({
      narrationUrl
    });
  };

  handleNarratClick = type => show => {
    ((type === 'desktop' && !this.state.showNarration) ||
      (type === 'mobile' && !this.state.showMobileNarration)) &&
      window.analytics &&
      window.analytics.track('NARRATION_OPEN', {
        cardId: this.props.rootQ.pid
      });
    ((type === 'desktop' && this.state.showNarration) ||
      (type === 'mobile' && this.state.showMobileNarration)) &&
      window.analytics &&
      window.analytics.track('NARRATION_CLOSE', {
        cardId: this.props.rootQ.pid
      });
    this.setState({
      showNarration:
        type === 'desktop'
          ? typeof show === 'boolean'
            ? show
            : !this.state.showNarration
          : this.state.showNarration,
      showMobileNarration:
        type === 'mobile'
          ? typeof show === 'boolean'
            ? show
            : !this.state.showMobileNarration
          : this.state.showMobileNarration
    });
  };

  /**
   * This event is fired when video has 'ended'
   */
  videoEndedEvent = () => {
    if (window.isActive && window._isFocused) {
      this.nextPressed(LessonEventsFromEnum.System);
    }
  };

  toggleFullscreen = fullScreen => {
    if (typeof fullScreen === 'boolean') {
      this.setState({
        fullScreen
      });
    } else {
      this.setState({
        fullScreen: !this.state.fullScreen
      });
    }
  };

  markCompleteCard = card => {
    if (
      this.props.rootQ.performance.completionStatus !== 'COMPLETE' ||
      !card.cardPerformanceComplete
    ) {
      const cardTopView = this.refs.cardTopView && this.refs.cardTopView.refs.component;
      cardTopView &&
        cardTopView.postMarkComplete &&
        cardTopView.postMarkComplete(true, false, card);
    }
  };

  renderLockedState = (lockedStatus, isAccessible) => {
    if (isAccessible === false) {
      return (
        <div style={styles.lockedStatusContainer}>
          <Icon icon="lock-icon" size="85px" fill="#9ea7b1" viewBox="0 0 36 46" />
          <p style={styles.lockedStatusText}>To view this lesson, complete all previous lessons.</p>
        </div>
      );
    }
    return (
      <div style={styles.lockedStatusContainer}>
        <Icon icon="lock-icon" size="85px" fill="#9ea7b1" viewBox="0 0 36 46" />
        <p style={styles.lockedStatusText}>THIS LESSON IS LOCKED..</p>
        <p style={styles.lockedStatusInst}>
          To view this lesson, complete the following {lockedStatus.length}{' '}
          {lockedStatus.length > 1 ? 'lessons' : 'lesson'}:
        </p>
        {lockedStatus}
      </div>
    );
  };

  renderStickyNarrationPlayer = () => {
    if (
      this.props.windowWidth < 768 &&
      this.state.narrationUrl
      /* && this.props.rootQ.resource
      && this.props.rootQ.resource.narrationUrl */
    ) {
      return (
        <StickyNarrationPlayer
          cardId={this.props.rootQ.pid}
          narrationUrl={this.props.rootQ.resource.narrationUrl}
          show={true}
          showNarration={this.state.showMobileNarration}
          handleMobileNarratClick={this.handleNarratClick('mobile')}
        />
      );
    }
  };

  renderCardContents({ isMobile = false }) {
    const cardArray = this.props.cardArray;
    const currentCardIndex = this.props.cardArrayCurrentCardIndex;
    const isEnrolled = !!this.props.rootQ.performance;
    const startsFromFirst = this.state.startsFromFirst;
    this.state.startsFromFirst = true;
    const switchToNextCardOnVideoEnd = this.props.rootQ.autoSwitch;
    const isNextScorm = cardArray[currentCardIndex + 1]
      ? cardArray[currentCardIndex + 1].resource.type === 'scorm'
      : false;
    // if(this.props.rootQ.resource.type !== 'pdf') this.state.fullScreen = false;
    if (!this.props.rootQ.resource) return null;
    // console.log(this.props.rootQ.description);
    if (
      (this.props.lockedStatus && this.props.lockedStatus.length > 0) ||
      !this.props.isAccessible
    ) {
      return this.renderLockedState(this.props.lockedStatus, this.props.isAccessible);
    }
    switch (this.props.rootQ.resource.type) {
      case 'video':
        return (
          <VideoPlayer
            ref="videoCard"
            cardId={this.props.rootQ.pid}
            card={this.props.rootQ.resource.content}
            videoWatched={this.videoWatched}
            watched={
              (this.props.rootQ.performance &&
                this.props.rootQ.performance.completionStatus === 'COMPLETE') ||
              false
            }
            switchToNextCardOnVideoEnd={switchToNextCardOnVideoEnd}
            videoEndedEvent={this.videoEndedEvent}
          />
        );
      case 'audio':
        return <AudioCard cardId={this.props.rootQ.pid} card={this.props.rootQ.resource.content} />;
      case 'html':
        return <HTMLCard cardId={this.props.rootQ.pid} card={this.props.rootQ.resource.content} />;
      case 'blocks':
        return (
          <BlockCard
            rootQ={this.props.rootQ}
            courseId={this.props.course.pid}
            setScrollPM={this.setScrollPM}
            preview={!!this.props.previewCourse}
            guestMode={this.props.guestMode}
          />
        );
      case 'pdf':
        return (
          <PDFCard
            cardId={this.props.rootQ.pid}
            card={this.props.rootQ.resource.content}
            toggleFullscreen={this.toggleFullscreen}
            fullScreen={this.state.fullScreen}
          />
        );
      case 'assignment':
        return (
          <AssignmentCard
            ref="assignmentCard"
            rootQ={this.props.rootQ}
            userId={this.props.relay.variables.userId}
            showEnrollDialog={this.props.showEnrollDialog}
            isEnrolled={isEnrolled}
            course={this.props.course}
            startsFromFirst={startsFromFirst}
            cardArray={this.props.cardArray}
            cardArrayCurrentCardIndex={this.props.cardArrayCurrentCardIndex}
            fullScreen={this.state.fullScreen}
            toggleFullscreen={this.toggleFullscreen}
            userObj={this.props.userObj}
            pathInfo={this.props.pathInfo}
            preview={!!this.props.previewCourse}
            guestMode={this.props.guestMode}
            lessonProgressChangeCallback={this.props.lessonProgressChangeCallback}
          />
        );
      case 'objective':
        return (
          <ObjectiveAssignmentCard
            rootQ={this.props.rootQ}
            userId={this.props.relay.variables.userId}
            course={this.props.course}
            pathInfo={this.props.pathInfo}
            userObj={this.props.userObj}
            preview={!!this.props.previewCourse}
            guestMode={this.props.guestMode}
            isMobile={isMobile}
            isAssignmentFullScreen={this.state.isAssignmentFullScreen}
            updateAssignmentScreenStatus={this.updateAssignmentScreenStatus}
            menuOpen={this.props.menuOpen}
            cardListMenuBtn={this.cardListMenuBtn || null}
            lessonProgressChangeCallback={this.props.lessonProgressChangeCallback}
          />
        );
      case 'peerReview':
        return (
          <PeerReview
            previousCard={this.props.previousCard}
            rootQ={this.props.rootQ}
            course={this.props.course}
            userId={this.props.relay.variables.userId}
            courseId={this.props.course.pid}
            isEnrolled={isEnrolled}
          />
        );
      case 'scorm':
        return (
          <div
            style={
              this.props.rootQ.newWindow
                ? styles.scormCardContainer
                : styles.scormCardInlineContainer
            }
          >
            <SCORMCard
              card={this.props.rootQ}
              course={this.props.course}
              rootQ={this.props.rootQ.performance && this.props.rootQ.performance.scorm}
              toggleFullscreen={this.toggleFullscreen}
              fullScreen={this.state.fullScreen}
              markCompleteCard={this.markCompleteCard}
              isEnrolled={isEnrolled}
              userObj={this.props.userObj}
              pathInfo={this.props.pathInfo}
              isNextScorm={isNextScorm}
              preview={!!this.props.previewCourse}
              guestMode={this.props.guestMode}
            />
          </div>
        );
      case 'survey':
        return (
          <AssignmentCard
            ref="assignmentCard"
            rootQ={this.props.rootQ}
            userId={this.props.relay.variables.userId}
            showEnrollDialog={this.props.showEnrollDialog}
            isEnrolled={isEnrolled}
            course={this.props.course}
            startsFromFirst={startsFromFirst}
            cardArray={this.props.cardArray}
            cardArrayCurrentCardIndex={this.props.cardArrayCurrentCardIndex}
            fullScreen={this.state.fullScreen}
            toggleFullscreen={this.toggleFullscreen}
            userObj={this.props.userObj}
            pathInfo={this.props.pathInfo}
            preview={!!this.props.previewCourse}
            guestMode={this.props.guestMode}
          />
        );
      default:
        console.log('New card type found ', this.props.rootQ.resource.type);
        throw new Error('no card type found');
    }
  }

  resubmitClicked = () => {
    this.refs.assignmentCard &&
      this.refs.assignmentCard.refs.component.resubmitClick &&
      this.refs.assignmentCard.refs.component.resubmitClick(true)();
  };

  render() {
    // const isDarkTheme = this.context.getFeatureFlag && this.context.getFeatureFlag('dark-theme');
    const isDarkTheme = this.props.darkTheme;
    const sideViewMarginLeft = isDarkTheme ? styles.marginLeft400 : styles.marginLeft320;
    const card = this.props.rootQ;
    const performance = card.performance;
    const slideCardWrapper = this.props.menuOpen && this.props.windowWidth > 767;
    const isMobile = this.props.windowWidth < 768;
    const { isAssignmentFullScreen } = this.state;
    // const isObjectiveAssessment =
    //   this.context.getFeatureFlag &&
    //   this.context.getFeatureFlag('new-assessment') &&
    //   this.props.rootQ.resource.type === 'objective';

    const isObjectiveAssessment = true && this.props.rootQ.resource.type === 'objective';
    const cardWrapperStyle = [
      styles.main,
      slideCardWrapper ? sideViewMarginLeft : styles.marginLeft0,
      this.state.fullScreen ? { zIndex: 25 } : null,
      this.props.showNext ? styles.nextButtonPadding : null,
      isObjectiveAssessment ? styles.objectiveAssessmentBG : styles.whiteBG
    ];
    const isLiveClass = this.props.isLiveClass;
    return (
      <div
        style={cardWrapperStyle}
        id="CardWrapper"
        className={`${this.props.menuOpen ? 'menuOpen' : ''} ${isMobile ? 'isMobile' : ''}`}
      >
        <CardTopView
          ref="cardTopView"
          rootQ={this.props.rootQ}
          course={this.props.course}
          userId={this.props.relay.variables.userId}
          narratClick={this.handleNarratClick('desktop')}
          narrationUrl={this.state.narrationUrl}
          showNarration={this.state.showNarration}
          positionObj={this.props.positionObj}
          userObj={this.props.userObj}
          cardListMenuBtn={this.cardListMenuBtn || null}
          cardArray={this.props.cardArray}
          cardArrayCurrentCardIndex={this.props.cardArrayCurrentCardIndex}
          menuOpen={this.props.menuOpen}
          cardLocked={this.props.lockedStatus.length > 0 || !this.props.isAccessible}
          previewCourse={this.props.previewCourse}
          guestMode={this.props.guestMode}
          pathInfo={this.props.pathInfo}
          windowWidth={this.props.windowWidth}
          requiredCardDuration={this.cardDuration}
          timeRemaining={this.state.timeRemaining}
          backToCourse={this.props.backToCourse}
          resubmitClicked={this.resubmitClicked}
          isScormOnlyCourse={this.props.isScormOnlyCourse}
          isLiveClass={this.props.isLiveClass}
          isLiveClassTeacher={this.props.teacher}
          hideSideMenu={this.props.hideSideMenu}
          lessonProgressChangeCallback={this.props.lessonProgressChangeCallback}
          isDarkTheme={isDarkTheme}
        />
        <div
          id="CardInternalContainer"
          style={[
            styles.contentWrapper,
            card.resource.type === 'blocks' || (card.resource.type === 'scorm' && !card.newWindow)
              ? styles.blocksWrapperStyle
              : null,
            card.resource.type === 'scorm' && card.newWindow ? styles.scormNewWindowStyle : null,
            this.state.fullScreen ? { zIndex: 4 } : { zIndex: 2 },
            isMobile ? styles.mobileContentWrapper : null,
            isAssignmentFullScreen ? { zIndex: 22 } : null
          ]}
          className={isLiveClass ? liveClassCardContainer : cardInternalContainer}
        >
          {this.renderCardContents({ isMobile })}
        </div>
        {this.props.showNext
          ? this.renderNextArrow(this.props.cardArray, this.props.cardArrayCurrentCardIndex, card)
          : null}
        {this.renderStickyNarrationPlayer()}
        <Style rules={styles.classBased} />
      </div>
    );
  }
}

const styles = {
  classBased: {
    'body.shareApp': {
      marginTop: '0px'
    },
    '.cardNextArrowWrapper': {
      position: 'absolute',
      bottom: '0px',
      height: '70px',
      left: '0px',
      width: '100%',
      zIndex: '3',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#eaecf2',
      flexDirection: 'column',
      cursor: 'pointer',
      border: '1px solid #d7e0eb'
    },
    '.arrowWrapperHead': {
      fontSize: '10px',
      lineHeight: '12px',
      fontWeight: '600',
      color: 'rgba(131, 146, 167, 0.67)',
      textTransform: 'uppercase',
      letterSpacing: '0.2px',
      fontFamily: 'ProximaNova-Semibold'
    },
    '.lessonName': {
      fontSize: '13px',
      lineHeight: '16px',
      margin: '5px 0 5px',
      fontWeight: '600',
      transition: 'all 80ms linear',
      fontFamily: 'ProximaNova-Semibold',
      color: '#8392a7'
    },
    '.goToNextLesson.lessonName': {
      fontSize: '12px',
      lineHeight: '15px',
      margin: '6px 0 4px',
      fontWeight: '600',
      transition: 'all 80ms linear',
      fontFamily: 'ProximaNova-Semibold',
      color: '#929dae',
      textTransform: 'uppercase'
    },
    '.currentSesstionRemainingTime': {
      fontSize: '16px',
      lineHeight: '20px',
      color: '#aab2bd',
      fontFamily: 'ProximaNova',
      display: 'flex',
      alignItems: 'center'
    },
    '.remainingTimeIconHolder': {
      marginRight: '8px'
    },
    '.cardNextArrowWrapper:hover .lessonName': {
      color: '#4a90e2'
    },
    '.cardNextArrowWrapper svg': {
      transition: 'all 80ms linear'
    },
    '.cardNextArrowWrapper:hover svg': {
      fill: '#4a90e2!important'
    },
    '.learninCardNextArrowWrapper:hover .remainingTimeIconHolder svg': {
      fill: '#c5d0de!important'
    }
  },
  main: {
    fontFamily: 'ProximaNova',
    display: 'flex',
    flexDirection: 'column',
    // height: '100vh',
    transition: 'margin 0.5s ease',
    // paddingBottom: '68px',
    position: 'relative',
    zIndex: '20',
    minHeight: '100vh'
  },
  whiteBG: {
    backgroundColor: '#fff'
  },
  objectiveAssessmentBG: {
    backgroundColor: '#fafafa'
  },
  marginLeft320: {
    marginLeft: '320px'
  },
  marginLeft400: {
    marginLeft: '400px'
  },
  marginLeft0: {
    marginLeft: '0px'
  },
  nextButtonPadding: {
    paddingBottom: '70px'
  },
  contentWrapper: {
    width: '100%',
    maxWidth: '800px',
    margin: '0px auto 30px',
    // backgroundColor: '#fff',
    backgroundColor: 'transparent',
    // border: '1px solid #DBE2E8',
    minHeight: 'calc(100vh - 100px)',
    zIndex: '2',
    padding: '202px 20px 0px',
    transition: 'padding 0.3s ease'
    // overflow: 'auto'
  },
  mobileContentWrapper: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: '145px'
  },
  cardStatusBarPadding: {
    paddingTop: '110px'
  },
  contentWrapperForscorm: {
    height: '100vh',
    zIndex: '2',
    paddingTop: '0px',
    margin: '0px auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  cardContentWrapper: {
    width: '680px'
  },
  contentWrapperMoreMargin: {
    margin: '68px auto 80px'
  },
  lockedStatusContainer: {
    padding: '80px 0 0 0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '0 auto',
    maxWidth: '500px'
  },
  lockedStatusText: {
    color: '#8c98a2',
    fontWeight: '600',
    letterSpacing: '0.8px',
    padding: '27px 0 15px 0'
  },
  lockedStatusInst: {
    color: '#8c98a2',
    fontSize: '15px',
    letterSpacing: '0.2px',
    padding: '0 0 6px 0',
    fontWeight: '500'
  },
  blocksWrapperStyle: {
    maxWidth: '100%',
    width: '100%',
    margin: '0px auto 100px',
    padding: '78px 0px 0px'
  },
  scormNewWindowStyle: {
    maxWidth: '100%',
    width: '100%',
    margin: '0px auto 100px',
    padding: '78px 0px 0px',
    minHeight: 'auto'
  },
  scormCardContainer: {
    height: 'calc(100vh - 270px)',
    zIndex: '2',
    margin: '0px auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  scormCardInlineContainer: {
    // height: 'calc(100vh - 260px)',
    zIndex: '2',
    margin: '0px auto',
    display: 'flex',
    alignItems: 'center'
    // justifyContent: 'center'
  },
  cardInfoContainer: {
    // maxWidth: '800px',
    padding: '0px 0px 33px',
    margin: '0 auto',
    fontFamily: 'ProximaNova'
  },
  cardInfoContainerWidth: {
    maxWidth: '800px',
    padding: '0px 20px 33px'
  },
  lessonCount: {
    color: '#8392a7',
    fontSize: '12px',
    fontWeight: '500',
    letterSpacing: '0.4px',
    textTransform: 'uppercase',
    marginBottom: '10px'
  },
  lessonTitle: {
    color: '#3b4859',
    fontSize: '32px',
    fontWeight: '500',
    letterSpacing: '-0.5px',
    lineHeight: '1.2em'
  }
};

export default Relay.createContainer(WindowResize(LearnerCard), {
  initialVariables: {
    userId: null
  },
  fragments: {
    rootQ: variables => Relay.QL`
      fragment on Card {
        id
        pid
        rawData
        type
        name
        description
        globalPosition
        duration
        contributeToSuccessStatus
        completionType
        isGradable
        autoPlay
        newWindow
        autoSwitch
        minProgressMeasure
        updatedAt
        ${BlockCard.getFragment('rootQ')}
        ${CardTopView.getFragment('rootQ', {
          userId: variables.userId
        })}
        ${AssignmentCard.getFragment('rootQ', {
          userId: variables.userId
        })}
        ${PeerReview.getFragment('rootQ', {
          userId: variables.userId
        })}
        ${ObjectiveAssignmentCard.getFragment('rootQ', {
          userId: variables.userId
        })}
        performance(userId: $userId) {
          id
          completionStatus
          timeSpent
          successStatus
          reAttemptCount
          scaledScore
          rawScore
          scaledProgressMeasure
          progressMeasure
          scorm {
            score_raw
            mastery_score
            scormData
          }
        }
        resource {
          type
          content {
            data
            url
            thumbUrl
          }
          narrationUrl
        }
      }
    `
  }
});
